import React from 'react';
import Logo from './Logo';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <Logo width={80} height={80} className="footer-logo-svg" />
              <div className="footer-logo-text">
                <h3>The MINT School</h3>
                <p>Building A Solid Foundation</p>
              </div>
            </div>
            <p className="footer-description">
              Committed to providing quality education and nurturing young minds 
              in Asa-Otukpo, Benue State. We believe in building a solid foundation 
              for our students' future success.
            </p>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><a href="/">Home</a></li>
              <li><a href="/about">About Us</a></li>
              <li><a href="/academics">Academics</a></li>
              <li><a href="/admissions">Admissions</a></li>
              <li><a href="/contact">Contact</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact Info</h4>
            <div className="contact-info">
              <div className="contact-item">
                <span className="contact-icon">📍</span>
                <span>Asa-Otukpo, Benue State, Nigeria</span>
              </div>
              <div className="contact-item">
                <span className="contact-icon">📞</span>
                <span>+234 XXX XXX XXXX</span>
              </div>
              <div className="contact-item">
                <span className="contact-icon">✉️</span>
                <span>info@themintschool.edu.ng</span>
              </div>
            </div>
          </div>

          <div className="footer-section">
            <h4>Follow Us</h4>
            <div className="social-links">
              <a href="https://facebook.com" className="social-link" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
                <span>📘</span>
              </a>
              <a href="https://twitter.com" className="social-link" aria-label="Twitter" target="_blank" rel="noopener noreferrer">
                <span>🐦</span>
              </a>
              <a href="https://instagram.com" className="social-link" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
                <span>📷</span>
              </a>
              <a href="https://linkedin.com" className="social-link" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
                <span>💼</span>
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; 2024 The MINT School. All rights reserved.</p>
            <div className="footer-bottom-links">
              <a href="/privacy">Privacy Policy</a>
              <a href="/terms">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
